import { getToken, isTokenExpired } from './authService';
import { handleSessionEnd } from './common';

export function authHeader() {
    const token = getToken();

    if (!token) {
        return {};
    }

    if (isTokenExpired()) {
        handleSessionEnd('expired');
        return {};
    }

    return { sessionToken: token };
}
